import { render, staticRenderFns } from "./view-area.vue?vue&type=template&id=c472f6c4&scoped=true"
import script from "./view-area.ts?vue&type=script&lang=ts&external"
export * from "./view-area.ts?vue&type=script&lang=ts&external"
import style0 from "./view-area.vue?vue&type=style&index=0&id=c472f6c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c472f6c4",
  null
  
)

export default component.exports